import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Typography, Divider, Button, Paper, Grid, Box, Fab, CircularProgress, Backdrop } from '@material-ui/core'
import { ArrowBackIosRounded } from '@material-ui/icons'
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles';

// Components
import CreateLiquidation1stPage from './components/CreateLiquidation1stPage'
import CreateLiquidations2ndPage from './components/CreateLiquidations2ndPage'
import SideNav from 'components/sidenav/Sidenav'

// StandardComponents
import SubmissionValidator from 'StandardComponents/SubmissionValidator/SubmissionValidator'
import TransactionSubmitValidation from 'StandardComponents/TransactionSubmitValidation/TransactionSubmitValidation'

// Helpers
import onChangeAutoComplete from './commons/onChange'
import onClickAutoComplete from './commons/onClick'
import HEADERS from './commons/headers'


// Services
import TransactionServices from 'Services/Api/NonPOItem/nonPOItem'
import AuthServices from 'Services/Api/Auth/Auth'
import WTaxRateServices from 'Services/Api/MasterData/wTaxRate'
import GLAccountByTypesServices from 'Services/Api/GLAccounts/glAccounts'
import ProjectsServices from 'Services/Api/MasterData/project'

// Validators
import CreateNonPOItemsFirstPageValidator from './CreateLiquidationFirstPageValidator'

// Styles
import classes from './CreateLiquidation.module.scss'

const params = {
  order: true,
  orderBy: '_id',
  sort: 1,
  limit: 50,
  search: toString()
}

const _allowedFieldsFirstPage = {
  dueDate: '',
  vendor: '',
  department: '',
  particulars: '',
  project: '',
  releasingCenter: '',
  selectedFile: '',
  requestingGrossPrice: 0.0,
  requestingAmount: 0.0,
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  circular: {
    color: 'red'
  },
  label: {
    marginLeft: '1px',
    color: 'white'
  }
}))

export default function CreateLiquidation(props) {
  const id = props.match.params.id
  const status = props.match.params.status
  const type = props.match.params.type
  const history = useHistory()
  const classes2 = useStyles()
  const [value, setValue] = React.useState({
    dueDate: '',
    vendor: '',
    department: '',
    particulars: '',
    poNumber: '',
    crfNumber: '',
    rejectionMessage: {},
    CAStatus: 'close',
    refCRF: '',
    file: null,
    selectedFile: '',
    selectedFile2: '',
    project: '',
    amount: 0,
    subProject: '',
    releasingCenter: 'BDO Examiner',
    projectClass: [
      {
        glCategory: '',
        glAccount: '',
        description1: '',
        description2: '',
        itemNumber: '',
        grossPricePerItem: 0,
        netPricePerItem: 0,
        quantity: 1,
        costType: '1OV',
        vatType: 'None IVAT-X1',
        vatTypeValue: 1,
        wTax: 0,
        wTaxType: 'X1 (None)',
        wTaxRate: 0,
        // file: null,
        // selectedFile: '',
        wTaxTypeValue: 0,
        wTaxTypeString: '',
        unitPrice: 0,
        subNetPrice: 0,
        projectClass: '',
        subTotalGrossPrice: 0.0,
        subTotalNetPrice: 0.0,
        classDepartment: ''
      }
    ],
    requestingGrossPrice: 0.0,
    requestingAmount: 0.0
  })
  const [suggestionsVendor, setSuggestionsVendors] = React.useState([])
  const [suggestionsRequestingDepartment, setSuggestionsRequestingDepartment] = React.useState([])
  const [suggestionsProjects, setSuggestionsProject] = React.useState([])
  const [suggestionReleasingCenter, setSuggestionsReleasingCenter] = React.useState(['STP', 'BDO Examiner', 'GIL PUYAT COR PASEO', 'BDO FiveEcom'])
  const [suggestionGLCategory, setSuggestionGLCategory] = React.useState([])
  const [suggestionGLAccounts, setSuggestionGLAccounts] = React.useState([])
  const [suggestionsVatType, setSuggestionsVatType] = React.useState([])
  const [suggestionsWtaxRate, setSuggestionsWtaxRate] = React.useState([])
  const [suggestionsItemNumber, setSuggestionsItemNumber] = React.useState([])
  const [selectedFile, setSelectedFile] = React.useState({})
  const [suggestionadvanceProjectClass, setSuggestionAdvanceProjectClass] = React.useState([])
  const [selectedDate, setSelectedDate] = React.useState(new Date())
  const [next, setNext] = React.useState(false)
  const [indexer, setIndexer] = React.useState(0)
  const [fileError, setFileError] = React.useState('wrong')
  const [submitDisable, setSubmitDisable] = React.useState(false)
  const [errorCollection, setErrorCollection] = React.useState([])
  const [openDialog, setOpenDialog] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [crfNumber, setCRFNumber] = React.useState('')
  const [disabled, setDisabled] = React.useState(false)
  const [buttonColor, setButtonColor] = React.useState('red')
  const [isCAStatus, setIsCAStatus] = React.useState(false)
  const [validatedProjectClasses, getValidatedProjectClasses] = React.useState([])
  const [headers, setHeaders] = React.useState([])

  const handleOnChangeCAStatus = e => {
    setIsCAStatus(e.target.checked)
  }

  React.useEffect(() => {
    if (id != 'new-transaction') {
      let _params = {
        sort: 1,
        ...params
      }
      TransactionServices.getById(id).then(response => {
        const data = response.data.data
        const projectClass = [...data.projectClasses]
        projectClass.map((item, index) => {
          projectClass[parseInt(index)]['subTotalGrossPrice'] = item.apv.subTotalGrossPrice ? item.apv.subTotalGrossPrice : 0
          projectClass[parseInt(index)]['subTotalNetPrice'] = item.apv.subTotalNetPrice ? item.apv.subTotalNetPrice : 0
          if (data.status !== 'Draft') {
            projectClass[parseInt(index)]['glCategory'] = data.requestType !== 'Cash Advance' ? item.glAccount.accountType : ''
            projectClass[parseInt(index)]['description1'] = data.requestType !== 'Cash Advance' ? item.description1 : ''
            projectClass[parseInt(index)]['glAccount'] = data.requestType !== 'Cash Advance' ? item.glAccount.accountCode + ' ' + item.glAccount.accountName : ''
          }
        })
        _params.search = data.vendor.bpName
        TransactionServices.getVendorMapping(_params).then(res => {
          const data = res.data.data
          const vendor = []
          const taxRate = []
          data.vendor.map(items => {
            vendor.push(items.bpName)
          })
          if (data.wTaxRate.length <= 0) {
            taxRate.push('X1 (None)')
          } else {
            data.wTaxRate.map(items => {
              taxRate.push(`${items.wTaxCode} ${items.wTaxDisplayName}`)
            })
          }

          const vatType = []
          data.vatType.map(items => {
            vatType.push(items === 'IVAT-S' ? 'Services IVAT-S' : items === 'IVAT-G' ? 'Goods IVAT-G' : 'None IVAT-X1')
          })
          setSuggestionsVatType(vatType)
          setSuggestionsWtaxRate(taxRate)
          setSuggestionsVendors(vendor)
        })
        _params.search = data.project.projectName
        ProjectsServices.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items.projectName)
          })
          setSuggestionsProject(newData)
        })
        setSelectedDate(data.dueDate)
        let requestingGrossPrice = 0.0
        let requestingAmount = 0.0
        for (let obj of projectClass) {
          requestingGrossPrice =
            parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice)
          requestingAmount =
            parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount)
        }
        setTimeout(function () {
          setValue({
            status: data.status,
            dueDate: data.dueDate,
            vendor: data.vendor.bpName,
            crfNumber: data.crfNo,
            selectedFile2: data.supportingDocuments,
            selectedFile: data.requestType === 'Liquidation' ? data.supportingDocuments : '',
            // selectedFile: data.supportingDocuments,
            department: data.department.centerName,
            releasingCenter: data.releasingCenter,
            project: data.project.projectName,
            particulars: data.particulars,
            CAStatus: 'close',
            subProject: data.subProject,
            rejectionMessage: data.rejectionMessage,
            amount: data.amount,
            status: data.status,
            projectClass: projectClass,
            requestingGrossPrice: requestingGrossPrice.toFixed(2),
            requestingAmount: requestingAmount.toFixed(2),
          })
        }, 10)
      })
    }
  }, [id])

  React.useEffect(() => {
    if (isCAStatus) {
      setValue({
        ...value,
        CAStatus: 'partial'
      })
    } else {
      setValue({
        ...value,
        CAStatus: 'close'
      })
    }
  }, [isCAStatus])

  React.useEffect(() => {
    AuthServices.getUser().then(async res => {
      const dataFetched = res.data.data
      const departments = dataFetched.departments
      const depts = []
      departments.map(items => {
        depts.push(items.centerName)
      })
      setSuggestionsRequestingDepartment(depts)
    })
  }, [])

  React.useEffect(() => {
    GLAccountByTypesServices.getGLAccountByTypes().then(res => {
      const data = res.data.data
      const glCategory = []
      data.map(items => {
        glCategory.push(items)
      })
      if (value.project === 'Megawide Holdco' || value.project === 'Megawide - Holding Company') {
        const index = glCategory.indexOf('COC Expenses')
        glCategory.splice(index, 1)
      } else {
        const index = glCategory.indexOf('Admin Expenses')
        glCategory.splice(index, 1)
      }

      setSuggestionGLCategory(glCategory)
    })
  }, [value.project])

  React.useEffect(() => {
    setValue({
      ...value,
      dueDate: selectedDate
    })
  }, [selectedDate])
  const [errors, setErrors] = React.useState({
    firstPage: []
  })
  const [allowedFields, setAllowedFields] = React.useState({})

  const allowFields = () => {
    setAllowedFields(_allowedFieldsFirstPage)
  }

  const handleOnchange = (e, name) => {
    const val = e.target.value
    setValue({
      ...value,
      projectClass: [...value.projectClass],
      [name]: val
    })
  }
  const handleOnchangeProjectClass = (e, name, index) => {
    let projectClass = [...value.projectClass]
    projectClass[parseInt(index)][name] = name === 'grossPricePerItem' ? parseInt(e.target.value) : e.target.value
    setValue({ ...value, projectClass: projectClass })
    handleOnComputation()
  }

  setTimeout(() => {
    allowFields()
  }, 10)

  const getValidator = value => {
    let error = null
    error = CreateNonPOItemsFirstPageValidator({
      dueDate: String(value.dueDate),
      vendor: value.vendor,
      department: value.department,
      particulars: value.particulars,
      project: value.project,
      releasingCenter: value.releasingCenter,
    }).error
    if (error) {
      error = { ...error }
      console.group('Base Error')
        
      console.groupEnd()
      setErrors(state => ({ firstPage: state.firstPage, ...error }))
      return !!error
    }
  }

  const doValidateAll = data => {
    const firstPage = getValidator(data)
    setErrors(state => ({ ...state, firstPage }))
    return !!firstPage
  }

  const handOnNext = () => {
    setNext(true)
  }

  const onNextFunction = async () => {
    const data = {}
    for (let f in allowedFields) data[f] = value[f]
    const hasError = doValidateAll(data)
    if (hasError) {
      return
    }
    const filename = value.selectedFile.split('.')
    if (filename[filename.length - 1] !== 'pdf') {
      alert('Wrong File Extension')
      return
    }
    await handOnNext()
  }


  const handleOnResubmitDraft = (status) => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      project: value.project,
      amount: value.amount,
      _id: value._id,
      CAStatus: 'open',
      crfNumber: value.crfNumber,
      projectClasses: value.projectClass,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      requestType: 'Cash Advance',
      originalstatus: 'Draft',
      status: 'For Approval'
    }
    if (value.departmentApprover) data.departmentApprover = value.departmentApprover
    if (value.accountingApprover) data.accountingApprover = value.accountingApprover
    if (!value.file) data.selectedFile = value.selectedFile
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.resubmit(form, id).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CheckRequest/${data._id}`)
    })
  }

  const handleOnSubmitReturnedTransaction = (status) => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      project: value.project,
      amount: value.amount,
      _id: value._id,
      CAStatus: 'open',
      crfNumber: value.crfNumber,
      projectClasses: value.projectClass,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      requestType: 'Liquidation',
      originalstatus: value.status,
      status: value.status
    }
    if (!value.file) data.selectedFile = value.selectedFile
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.resubmit(form, id).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CheckRequest/${data._id}`)
    })
  }

  // const handleOnSubmitReturnedTransaction = (status) => {
  //   setSubmitDisable(false)
  //   setLoading(true)
  //   let form = new FormData()
  //   const data = {
  //     dueDate: value.dueDate,
  //     department: value.department,
  //     vendor: value.vendor,
  //     project: value.project,
  //     amount: value.amount,
  //     selectedFile: value.selectedFile,
  //     refCRF: value.refCRF,
  //     CAStatus: value.CAStatus,
  //     projectClasses: value.projectClass,
  //     releasingCenter: value.releasingCenter,
  //     subProject: value.subProject,
  //     particulars: value.particulars,
  //     requestType: 'Liquidation',
  //     status: status
  //   }
  //   form.set('data', JSON.stringify(data))
  //   form.append('supportingDocuments', value.file)
  //   TransactionServices.resubmit(form, id).then(response => {
  //     const data = response.data.data
  //     if (data) setLoading(false)
  //     history.push(`/CheckRequest/${data._id}`)
  //   })
  // }

  const handleOnSubmitDraftTransaction = (status) => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      amount: value.amount,
      project: value.project,
      refCRF: value.refCRF,
      CAStatus: value.CAStatus,
      projectClasses: value.projectClass,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      requestType: 'Liquidation',
      status: status
    }
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.submitDraft(form, id).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/Liquidation/${data._id}`)
    })
  }

  const handleOnSubmitTransaction = (status) => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      project: value.project,
      amount: value.amount,
      refCRF: value.crfNumber,
      CAStatus: value.CAStatus,
      projectClasses: value.projectClass,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      requestType: 'Liquidation',
      status: status === 'For Approval' ? 'For Approval' : 'Draft'
    }
    if (data.status === 'Draft') {
      if (
        value.dueDate == '' ||
        value.requestingDepartment === '' ||
        value.vendor === '' ||
        value.project === '' ||
        value.releasingCenter === '' ||
        value.particulars === '' ||
        value.subProject === ''
      ) {
        setErrorCollection(["Please don't leave blank fields for it is needed for saving draft"])
        setOpenDialog(true)
      }
    }
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.submit(form).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CheckRequest/${data._id}`)
    })
  }

  const handlaOnSubmissionValidation = () => {
    setLoading(true)
    const validatedProjectClasses = []
    value.projectClass.map((item, index) => {
      if (
        item.glCategory === ''
        || item.glAccount === ''
        || item.description1 === ''
        || item.grossPricePerItem === 0
      ) {
        validatedProjectClasses.push({
          page: index + 1,
          glCategory: item.glCategory,
          glAccount: item.glAccount,
          description1: item.description1,
          grossPricePerItem: item.grossPricePerItem,
        })
      }

    })
    if (validatedProjectClasses.length > 0) {
      getValidatedProjectClasses(validatedProjectClasses)
      setHeaders(HEADERS.NON_PO_ITEMS)
      setOpenDialog(true)
    } else {
      if (status === 'Returned') {
        handleOnSubmitReturnedTransaction('For Approval')
      } else if (status === 'Draft') {
        handleOnSubmitDraftTransaction('For Approval')
      } else {
        handleOnSubmitTransaction('For Approval')
      }
    }
  }

  const handleOnAddProjectClass = () => {
    setValue({
      ...value,
      projectClass: [
        ...value.projectClass,
        {
          glCategory: '',
          glAccount: '',
          description1: '',
          description2: '',
          itemNumber: '',
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: '1OV',
          vatType: 'None IVAT-X1',
          vatTypeValue: 1,
          file: null,
          selectedFile: '',
          wTax: 0,
          wTaxType: 'X1 (None)',
          wTaxRate: '0',
          wTaxTypeValue: 0,
          wTaxTypeString: '',
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: '',
          subTotalGrossPrice: 0.0,
          subTotalNetPrice: 0.0,
          classDepartment: ''
        }
      ]
    })
  }

  const handleOnSubmitDraft = () => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      project: value.project,
      crfNumber: crfNumber,
      projectClasses: value.projectClass,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      requestType: 'Liquidation',
      status: 'Draft'
    }
    if (data.status === 'Draft') {
      if (value.dueDate == '' ||
        value.requestingDepartment === '' ||
        value.vendor === '' ||
        value.project === '' ||
        value.releasingCenter === '' ||
        value.particulars === '' ||
        value.subProject === '') {
        setOpenDialog(true)
      }
    }
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.storeDraft(form).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CheckRequest/${data._id}`)
    })
  }

  const handleOnChangeSelect = (e, name, isProjectClass, index) => {
    if (isProjectClass) {
      let projectClass = [...value.projectClass]
      projectClass[parseInt(index)][name] = name === 'grossPricePerItem' ? parseInt(e.target.value) : e.target.value
      setValue({ ...value, projectClass: projectClass })
    } else {
      setValue({
        ...value,
        [e.target.name]: e.target.value
      })
    }

  }

  const handleOnCloseProjectClass = index => {
    const projectClass = [...value.projectClass]
    projectClass.splice(index, 1)
    setValue({
      ...value, projectClass: projectClass
    })
  }

  const handleOnComputation = () => {
    const projectClass = value.projectClass
    const data = {}
    projectClass.map(async (item, index) => {
      let _params = {
        ...params,
        sort: 1,
      }
      _params.search = item.wTaxType.split(' ')[1]
      await WTaxRateServices.getMany(_params).then(res => {
        const taxRateData = res.data.data
        taxRateData.map(items => data.rate = items.rate)
      })
      const subTotalGrossPrice = item.quantity * item.grossPricePerItem
      const unitPrice = subTotalGrossPrice / (item.vatType === 'None IVAT-X1' ? 1 : 1.12)
      const netWTax = unitPrice * (data.rate * 0.01)
      const subTotalNetPrice = subTotalGrossPrice - netWTax
      projectClass[index].grossPricePerItem = item.grossPricePerItem
      projectClass[index].vatType = item.vatType
      projectClass[index].wTaxType = item.wTaxType
      projectClass[index].wTaxRate = data.rate
      projectClass[index].subTotalGrossPrice = subTotalGrossPrice.toFixed(2)
      projectClass[index].subTotalNetPrice =
        data.rate === '0'
          ? subTotalGrossPrice.toFixed(2)
          : subTotalNetPrice.toFixed(2)
      let requestingGrossPrice = 0.0
      let requestingAmount = 0.0
      for (let obj of projectClass) {
        requestingGrossPrice =
          parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice)
        requestingAmount =
          parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount)
      }
      setValue({
        ...value,
        projectClass,
        requestingGrossPrice: requestingGrossPrice.toFixed(2),
        requestingAmount: requestingAmount.toFixed(2)
      })
    })
  }

  const handleDownloadAttachment = id => {
    TransactionServices.downloadAttachment(id).then(response => {
      const url = URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${value.selectedFile2}.pdf`)
      document.body.appendChild(link)
      link.click()
    })
  }

  React.useEffect(() => {
    if (value.selectedFile !== '') {
      const filename = value.selectedFile.split('.')
      if (filename[filename.length - 1] !== 'pdf') {
        setFileError('wrong')
        setButtonColor('red')
        setDisabled(true)
      } else {
        setButtonColor('green')
        setFileError('correct')
        setDisabled(false)
      }
    }
  }, [value.selectedFile])

  return (
    <React.Fragment>
      <Box className={classes.main_root}>
        <div id='sidePanel' className={classes.side_panel}>
          <SideNav
          />
        </div>
        <Box className={classes.root}>
          {next ? (
            <div className={classes['back-button-container']}>
              <Fab className={classes.button} onClick={() => setNext(false)}>
                <ArrowBackIosRounded className={classes.icon} />
              </Fab>
            </div>
          ) :
            ('')}
          <Box className={classes.header}>
            <Typography className={classes['header-label']}>Liquidations</Typography>
            {/* <Typography className={classes['header-label-crf']}>{next ? `(${crfNumber})` : ''}</Typography> */}
          </Box>
          <Divider className={classes.divider} />
          <Box className={classes.body}>
            <Paper className={classes.paper}>
              <Grid constainer spacing={1} className={classes['paper-body']}>
                {value.status === 'Returned' || value.status === 'Rejected' ? (
                  <Grid item xs={12} sm={12}>
                    <Paper className={classes.return_message}>
                      <Typography className={classes.header}>Remarks:</Typography>
                      <Typography className={classes.value}>{value.rejectionMessage.message}</Typography>
                    </Paper>
                  </Grid>
                ) : ('')}
                <Grid container item xs={12} alignItems='flex-end' justify='flex-end'>
                  {/* <Button className={classes['save-button']} onClick={() => { handleOnSubmitDraft('Draft') }}>Save</Button> */}
                  <Button className={classes['header-cancel']}>
                    <Link to='/RequestSelection' style={{ textDecoration: 'none', color: 'white' }}>
                      Cancel
                    </Link>
                  </Button>
                </Grid>
                {next ? (
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <CreateLiquidations2ndPage
                      projectClass={value.projectClass}
                      value={value}
                      onChangeAutoComplete={onChangeAutoComplete}
                      onClickAutoComplete={onClickAutoComplete}
                      setSuggestionsRequestingDepartment={setSuggestionsRequestingDepartment}
                      setSuggestionGLCategory={setSuggestionGLCategory}
                      setSuggestionGLAccounts={setSuggestionGLAccounts}
                      setSuggestionsVatType={setSuggestionsVatType}
                      setSuggestionsItemNumber={setSuggestionsItemNumber}
                      suggestionsWtaxRate={suggestionsWtaxRate}
                      setSuggestionAdvanceProjectClass={setSuggestionAdvanceProjectClass}
                      params={params}
                      type={type}
                      setSuggestionsWtaxRate={setSuggestionsWtaxRate}
                      setIndexer={setIndexer}
                      handleOnComputation={handleOnComputation}
                      suggestionadvanceProjectClass={suggestionadvanceProjectClass}
                      setValue={setValue}
                      setFileError={setFileError}
                      fileError={fileError}
                      setSelectedFile={setSelectedFile}
                      selectedFile={selectedFile}
                      setButtonColor={setButtonColor}
                      buttonColor={buttonColor}
                      suggestionsRequestingDepartment={suggestionsRequestingDepartment}
                      suggestionGLCategory={suggestionGLCategory}
                      suggestionsItemNumber={suggestionsItemNumber}
                      suggestionGLAccounts={suggestionGLAccounts}
                      suggestionsVatType={suggestionsVatType}
                      handleOnchangeProjectClass={handleOnchangeProjectClass}
                      handleOnCloseProjectClass={handleOnCloseProjectClass}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <CreateLiquidation1stPage
                      classes={classes}
                      setSuggestionsVendors={setSuggestionsVendors}
                      setSuggestionsProject={setSuggestionsProject}
                      setSuggestionsRequestingDepartment={setSuggestionsRequestingDepartment}
                      params={params}
                      status={status}
                      isCAStatus={isCAStatus}
                      handleOnChangeCAStatus={handleOnChangeCAStatus}
                      type={type}
                      setValue={setValue}
                      setFileError={setFileError}
                      fileError={fileError}
                      handleDownloadAttachment={() => handleDownloadAttachment(id)}
                      setSuggestionsVatType={setSuggestionsVatType}
                      handleOnChangeSelect={handleOnChangeSelect}
                      onChangeAutoComplete={onChangeAutoComplete}
                      onClickAutoComplete={onClickAutoComplete}
                      setSuggestionsWtaxRate={setSuggestionsWtaxRate}
                      setSuggestionsReleasingCenter={setSuggestionsReleasingCenter}
                      suggestionReleasingCenter={suggestionReleasingCenter}
                      value={value}
                      selectedDate={selectedDate}
                      setButtonColor={setButtonColor}
                      buttonColor={buttonColor}
                      setSelectedDate={setSelectedDate}
                      suggestionsVendor={suggestionsVendor}
                      suggestionsRequestingDepartment={suggestionsRequestingDepartment}
                      suggestionsProjects={suggestionsProjects}
                      handleOnchange={handleOnchange}
                      setSelectedFile={setSelectedFile}
                      selectedFile={selectedFile}
                      errors={errors}
                    />
                  </Grid>
                )}
                <Grid container item xs={12} alignItems='flex-end' justify='flex-end'>
                  <Box>
                    {next ? (
                      <Grid container item xs={12}>
                        <Button
                          className={classes['footer-project']}
                          onClick={handleOnAddProjectClass}
                        >Add Project Class</Button>
                        <Button
                          className={classes['footer-submit']}
                          onClick={() => { setSubmitDisable(true) }}
                        >Submit</Button>
                      </Grid>
                    ) : (
                      <Button
                        className={classes['footer-next']}
                        // disabled={disabled}
                        onClick={onNextFunction}
                      >Liquidate</Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Box>
          <Backdrop className={classes2.backdrop} open={loading}>
            <CircularProgress className={classes2.circular} thickness={10} />
            <Typography className={classes2.label}>Loading....</Typography>
          </Backdrop>
        </Box>
        {openDialog && (
          <TransactionSubmitValidation
            openDialog={openDialog}
            title={'Non Po Items'}
            close={() => { setOpenDialog(false) }}
            rawData={validatedProjectClasses}
            setLoading={setLoading}
            headers={headers}
            setSubmitDisable={setSubmitDisable}
          />
        )}
        {submitDisable && (
          <SubmissionValidator
            openDialog={submitDisable}
            title={'Non Po Items'}
            CAStatus={value.CAStatus}
            handeSave={() => value.status === 'Returned' ? handleOnSubmitReturnedTransaction() : value.status === 'Draft' ? handleOnResubmitDraft() : handlaOnSubmissionValidation('For Approval')}
            close={() => { setSubmitDisable(false) }}
          />

        )}
      </Box>
    </React.Fragment>
  )
}
